/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthAdditionalDocumentCategory = {
    Facesheet: 'facesheet',
    SkilledNotesAndReviews: 'skilled_notes_and_reviews',
    ProgressNotes: 'progress_notes',
    OrderSummary: 'order_summary',
    VitalSignsAndLabs: 'vital_signs_and_labs',
    SkinAndWoundCare: 'skin_and_wound_care',
    TherapyEvaluation: 'therapy_evaluation',
    DailyTherapyNotes: 'daily_therapy_notes',
    TherapyProgressNotes: 'therapy_progress_notes',
    TherapyLog: 'therapy_log',
    DischargePlan: 'discharge_plan',
    Other: 'other',
} as const;
export type PalReauthAdditionalDocumentCategory = typeof PalReauthAdditionalDocumentCategory[keyof typeof PalReauthAdditionalDocumentCategory];


export function instanceOfPalReauthAdditionalDocumentCategory(value: any): boolean {
    for (const key in PalReauthAdditionalDocumentCategory) {
        if (Object.prototype.hasOwnProperty.call(PalReauthAdditionalDocumentCategory, key)) {
            if (PalReauthAdditionalDocumentCategory[key as keyof typeof PalReauthAdditionalDocumentCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthAdditionalDocumentCategoryFromJSON(json: any): PalReauthAdditionalDocumentCategory {
    return PalReauthAdditionalDocumentCategoryFromJSONTyped(json, false);
}

export function PalReauthAdditionalDocumentCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthAdditionalDocumentCategory {
    return json as PalReauthAdditionalDocumentCategory;
}

export function PalReauthAdditionalDocumentCategoryToJSON(value?: PalReauthAdditionalDocumentCategory | null): any {
    return value as any;
}

export function PalReauthAdditionalDocumentCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthAdditionalDocumentCategory {
    return value as PalReauthAdditionalDocumentCategory;
}

